// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3YcZG","twitterFollow":"footer-module--twitter-follow--29SLb","footerList":"footer-module--footerList--mBXsA"};